import React from 'react';

import PerformanceChart from '@features/crm/v3/dashboard/components/PerformanceChart';

import { compareCRMBrandWisePerformance, getCRMBrandWisePerformance } from '@services/crmService';

const BrandWisePerformance = () => {
	const dataFetchers = {
		compare: compareCRMBrandWisePerformance,
		get: getCRMBrandWisePerformance
	};
	return (
		<>
			<div className="brand-wise-performance-container">
				<PerformanceChart
					dataFetcher={dataFetchers}
					title="Brand-wise Performance"
					varName="brand"
					chartProperty={{
						barPercentage: 1,
						categoryPercentage: 0.5,
						borderRadius: 5
					}}
					numberOfBars={10}
				/>
			</div>
		</>
	);
};

export default BrandWisePerformance;
